import { base_url } from "@/config";

export const login_url: string = base_url + "api/Authentification/login";
export const register_url: string = base_url + "api/Authentification/register";
export const reset_pw_url: string =
  base_url + "api/Authentification/resetPassword";
export const confirmer_reception_url: string =
  base_url + "api/TRVendeur/VENDEURValiderTourneeRetour";
export const confirmer_reception_par_demande_url: string =
  base_url + "api/TRVendeur/VENDEURValiderTRViaDemande";
export const confirmer_reception_par_tournne_annulee_url: string =
  base_url + "api/TREntrepot/ValiderReceptionTRAnnuler";
export const list_motif_url: string =
  base_url + "api/TRVendeur/VENDEURMotifTourneeRetour";
export const list_motif_url_: string =
  base_url + "api/TRLitiges/TRMotifsLitiges";
export const list_motifs_annulation_url: string =
  base_url + "api/tourneeretour/motifs/list";
export const create_litige_url: string =
  base_url + "api/TRVendeur/VENDEURCreateLitigeTourneeRetour";
export const create_request_litige_url: string =
  base_url + "api/TRLitiges/TRLitigesVendeur";
export const product_details_url: string =
  base_url + "api/TREntrepot/TRGetArticleTourneeRetour";
export const litige_details_url: string =
  base_url + "api/TRLitiges/TRListLitiges?tourneeRetourId=";
export const liste_vendeurs_url: string =
  base_url + "api/TREntrepot/TRSellerTourneeRetour";
export const liste_vendeurs_avec_demandes_url: string =
  base_url + "api/tourneeretour/vendeurs?sourceId=";
export const liste_vendeurs_avec_demandes_non_vendable_url: string =
  base_url + "api/TREntrepot/TRSellerTourneeDemandesRetour";
export const liste_vendeurs_avec_demandes_vendable_url_: string =
  base_url + "api/TREntrepot/TRSellerTourneeDemandesStockDispo";
export const liste_vendeurs_avec_demandes_entrepot_url_: string =
  base_url + "api/TREntrepot/ListSellerByDemandesRepriseMMS";
export const create_tournee_url: string =
  base_url + "api/TREntrepot/TRCreateTourneeRetour";
export const generate_tournee_code_url: string =
  base_url + "api/TREntrepot/TRGetNumTourneeRetour";
export const confirmer_ramassage_url: string =
  base_url + "api/tourneeretour/livreur/validation";
export const rto_bulk_scan_colis_url = (trackingCode: string): string =>
  base_url +
  `api/tourneeretour/rto/scan/colis/${encodeURIComponent(trackingCode)}`;
export const rto_bulk_validation_url: string =
  base_url + "api/tourneeretour/rto/livreur/validation";
export const rto_bulk_expedition_validation_url: string =
  base_url + "api/tourneeretour/rto/provisoire/validation";
export const list_tournees_vendeur_url: string =
  base_url + "api/tourneeretour/vendeur/list/pagination";
export const list_tournees_entrepot_url: string =
  base_url + "api/tourneeretour/entrepot/list/pagination";
export const list_tournees_livreur_url: string =
  base_url + "api/tourneeretour/livreur/list/pagination";
export const list_tournees_expediteur_url: string =
  base_url + "api/tourneeretour/provisoire/list/pagination";
export const list_tournees_hub_url: string =
  base_url + "api/tourneeretour/hub/list/pagination";
export const list_tournees_annuler_vendeur_url: string =
  base_url + "api/tourneeretour/entrepot/list_annulation/pagination";
export const supprimer_tournee_url: string =
  base_url + "api/TREntrepot/TRRemoveTourneeRetour";
export const list_hub_url: string = base_url + "api/TRHub/HUBListHub";
export const list_hub_per_request_url: string =
  base_url + "api/tourneeretour/hub/list?demandeId=";
export const hub_reception_confirmation_url: string =
  base_url + "api/tourneeretour/hub/validation";
export const hub_non_vip_seller_validation_url: string =
  base_url + "api/tourneeretour/vendeur/validation_hub";
export const delivery_non_vip_seller_validation_url: string =
  base_url + "api/tourneeretour/vendeur/validation_livreur";
export const return_request_non_vendable_url: string =
  base_url + "api/TREntrepot/TRListDemandesRepriseByCodeSeller?codeSeller=";
export const return_requests_url = (
  sellerCode: string,
  sourceId: number
): string =>
  base_url +
  `api/tourneeretour/demandes?codeSeller=${sellerCode}&sourceId=${sourceId}`;
export const return_request_entrepot_url: string =
  base_url + "api/TREntrepot/ListDemandesRepriseByCodeSellerMMS?codeSeller=";
export const create_tournee_via_request_non_vendable_url: string =
  base_url + "api/TREntrepot/TRCreateTourneeRetourViaDemandesNonVendable";
export const create_tournee_via_request_vendable_url: string =
  base_url + "api/TREntrepot/TRCreateTourneeRetourViaDemandesStockDispo";
export const create_tournee_via_request_entrepot_url: string =
  base_url + "api/TREntrepot/TRCreateTourneeRetourViaDemandesMMS";
export const create_tournee_via_request_url: string =
  base_url + "api/tourneeretour/create";
export const annuler_tournee_url: string =
  base_url + "api/TRAnnulation/AnnulerTRViaDemande";
export const list_status_tounee: string =
  base_url + "api/tourneeretour/statuts/list";
export const list_motifs_annulation: string =
  base_url + "api/tourneeretour/motifs/list";
export const expedition_validation_url: string =
  base_url + "api/tourneeretour/provisoire/validation";
export const rto_package_tracking_url: string =
  base_url + "api/tourneeretour/suivi/";
export const partial_delivery_seller_reception_url: string =
  base_url + "api/tourneeretour/vendeur/reception_livreur_partial";
export const partial_hub_seller_reception_url: string =
  base_url + "api/tourneeretour/vendeur/reception_hub_partial";
export const partial_delivery_seller_validation_join_url: string =
  base_url + "api/tourneeretour/vendeur/validation_livreur_partial_join";
export const partial_hub_seller_validation_join_url: string =
  base_url + "api/tourneeretour/vendeur/validation_hub_partial_join";
